<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <div class="search-area">
            <CRow>
                <CCol sm="10" class="pr-1">
                    <input type="text" placeholder="Perusahaan" v-model="searchPerusahaan" class="form-control"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="6"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    </div>
    <div v-else class="area-edit">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow class="mt-3">
                    <CCol sm="2">
                        <span>Nama Perusahaan</span>
                    </CCol>
                    <CCol sm="1 text-right">
                        :
                    </CCol>
                    <CCol sm="3">
                        <span class="font-weight-bold">{{namaPerusahaan}}</span>
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="2">
                        <span>Tanggal Expired</span>
                    </CCol>
                    <CCol sm="1 text-right">
                        :
                    </CCol>
                    <CCol sm="3">
                        <span class="font-weight-bold">{{tanggalExpired}}</span>
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-input mb-1">
            <CCol sm="8"></CCol>
            <CCol sm="2 text-right pr-2 pt-2">
                Status
            </CCol>
            <CCol sm="2">
                <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataSearchStatus" class="form-control" v-model="selectedStatus" placeholder="Status"></model-select>
            </CCol>
        </CRow>
        <CRow class="area-input mb-5">
            <CCol sm="12">
                <CRow>
                    <CCol sm="6"></CCol>
                    <CCol sm="6">
                        <span style="float:right">
                            <CButton v-if="pageDetail == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                            <CButton v-else @click="movePageDetail('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                            <CButton v-if="pageDetail == totalPageDetail" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                            <CButton v-else @click="movePageDetail('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        </span>
                        <input @change="validatePageDetail(pageDetail)" v-if="totalPageDetail != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="pageDetail" class="text-center rounded p-1" type="text">
                        <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="pageDetail" class="text-center rounded p-1" type="text">
                        <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPageDetail}} - {{lastPageDetail}}</span> of {{totalRowDetail}}</span>
                        <!-- <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/> -->
                        <!-- <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/> -->
                    </CCol>
                </CRow>
                <CRow class="mt-1">
                    <table class="w-100">
                        <thead>
                            <tr>
                                <th>Periode</th>
                                <th>Tipe</th>
                                <th>User</th>
                                <th>Harga</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody v-if="datasDetail.length != 0">
                            <tr v-for="(item, index) in datasDetail" :key="index">
                                <td>{{item.periode}}</td>
                                <td>
                                    <span v-if="item.tipeBilling == 'S'">Satuan</span>
                                    <span v-if="item.tipeBilling == 'P'">Paket</span>
                                </td>
                                <td>
                                    <span v-if="item.tipeBilling == 'S'">{{separators(item.jumlahPegawai)}}</span>
                                    <span v-if="item.tipeBilling == 'P'">{{separators(item.maxPegawai)}}</span>
                                </td>
                                <td>
                                    <span v-if="item.tipeBilling == 'S'">{{rupiahModeUangSaku(item.hargaSatuan)}}</span>
                                    <span v-if="item.tipeBilling == 'P'">{{rupiahModeUangSaku(item.totalHarga)}}</span>
                                </td>
                                <td>
                                    <span v-if="item.status == 'A'">Lunas</span>
                                    <span v-if="item.status == 'B'">Menunggu Persetujuan</span>
                                    <span v-if="item.status == 'W'">Belum Lunas</span>
                                </td>
                                <td>
                                    <CButton
                                        @click="openModal(index)"
                                        v-if="item.status == 'B'"
                                        color="primary"
                                        variant="outline"
                                    >
                                    Action
                                    </CButton>
                                    <CButton
                                        @click="openModal(index)"
                                        v-if="item.status == 'A'"
                                        color="primary"
                                        variant="outline"
                                    >
                                    Result
                                    </CButton>
                                    <CButton
                                        @click="openModal(index)"
                                        v-if="item.status == 'W'"
                                        color="primary"
                                        variant="outline"
                                    >
                                    View
                                    </CButton>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="text-center" colspan="6">
                                    {{errorMessageDetail}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </CRow>
            </CCol>
        </CRow>
        <CModal
            size="xl"
            :centered="true"
            color="white"
            :show.sync="viewModal"
            :closeOnBackdrop="false"
        >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Detail Pembayaran Billing</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="closeModal()" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px">
                    <CRow class="mb-3">
                        <CCol sm="12">
                            <CRow>
                                <CCol sm="10">
                                    <CRow>
                                        <CCol sm="5">
                                            <span class="">Nama Perusahaan</span>
                                        </CCol>
                                        <CCol sm="1 text-right">
                                            :
                                        </CCol>
                                        <CCol sm="6">
                                            <span class="font-weight-bold">{{viewNamaPerusahaan}}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-1">
                                        <CCol sm="5">
                                            <span class="">Periode Tagihan</span>
                                        </CCol>
                                        <CCol sm="1 text-right">
                                            :
                                        </CCol>
                                        <CCol sm="6">
                                            <span class="font-weight-bold">{{viewPeriode}}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-1">
                                        <CCol sm="5">
                                            <span class="">Tipe</span>
                                        </CCol>
                                        <CCol sm="1 text-right">
                                            :
                                        </CCol>
                                        <CCol sm="6">
                                            <span class="font-weight-bold">{{viewSatuan}}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-1">
                                        <CCol sm="5">
                                            <span class="">Harga</span>
                                        </CCol>
                                        <CCol sm="1 text-right">
                                            :
                                        </CCol>
                                        <CCol sm="6">
                                            <span class="font-weight-bold">{{viewHarga}}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-1">
                                        <CCol sm="5">
                                            <span class="">Jumlah Pegawai</span>
                                        </CCol>
                                        <CCol sm="1 text-right">
                                            :
                                        </CCol>
                                        <CCol sm="6">
                                            <span class="font-weight-bold">{{separators(viewJumlahPegawai)}} Pegawai</span>
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-1">
                                        <CCol sm="5">
                                            <span class="">Jumlah yang ditagih</span>
                                        </CCol>
                                        <CCol sm="1 text-right">
                                            :
                                        </CCol>
                                        <CCol sm="6">
                                            <span class="font-weight-bold">{{viewTotalTagihan}}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-1">
                                        <CCol sm="5">
                                            <span class="">Jumlah yang dibayarkan</span>
                                        </CCol>
                                        <CCol sm="1 text-right">
                                            :
                                        </CCol>
                                        <CCol sm="6">
                                            <span class="font-weight-bold">{{viewTotalBayar}}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-1">
                                        <CCol sm="5">
                                            <span class="">Jumlah bulan yang dibayarkan</span>
                                        </CCol>
                                        <CCol sm="1 text-right">
                                            :
                                        </CCol>
                                        <CCol sm="6">
                                            <span class="font-weight-bold">{{viewJumlahBulan}} Bulan</span>
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-1">
                                        <CCol sm="5">
                                            <span class="">Status</span>
                                        </CCol>
                                        <CCol sm="1 text-right">
                                            :
                                        </CCol>
                                        <CCol sm="6">
                                            <span class="font-weight-bold">{{viewStatus}}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-1">
                                        <CCol sm="5">
                                            <span class="">Bukti Bayar</span>
                                        </CCol>
                                        <CCol sm="1 text-right">
                                            :
                                        </CCol>
                                        <CCol sm="6">
                                            <img :src="downloadIcon" v-if="viewTipePdf != 'Y'" @click="direct(viewBukti)" width="20px" height="20px" style="cursor:pointer"/>
                                            <img :src="downloadIcon" v-if="viewTipePdf == 'Y'" @click="showPdfBukti(viewBukti)" width="20px" height="20px" style="cursor:pointer"/>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="viewStatus == 'Lunas'" class="mt-1">
                                        <CCol sm="5">
                                            <span class="">Disetujui Oleh</span>
                                        </CCol>
                                        <CCol sm="1 text-right">
                                            :
                                        </CCol>
                                        <CCol sm="6">
                                            <span class="font-weight-bold">{{viewNamaApproval}} pada {{viewTanggalApprove}}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-1">
                                        <CCol sm="5">
                                            Keterangan
                                        </CCol>
                                        <CCol sm="1">
                                        </CCol>
                                        <CCol sm="6">
                                            <ul class="StepProgress">
                                                <li class="StepProgress-item" v-for="(item, index) in viewKeterangan" :key="'track'+index" :class="[item.status != 'Approved' ? 'is-done' : '']">
                                                    <div>
                                                        <span class="text-primary font-weight-bold">{{item.status}}</span>
                                                            by {{item.namaPegawai}} at {{item.tanggal}}
                                                    </div>
                                                    <div>{{item.keterangan}}</div>
                                                </li>
                                            </ul>
                                        </CCol>
                                    </CRow>
                                </CCol>
                                <CCol sm="2 text-right">
                                    <CButton
                                    color="danger"
                                    variant="outline"
                                    @click="showPdf(viewUnix)"
                                    >
                                    Invoice
                                    </CButton>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                    <CRow class="mb-3 mt-2">
                        <CCol sm="12">
                            <CButton v-if="viewStatus == 'Menunggu Persetujuan'" @click="onSave('A')" type="button" style="float:right" class="btn btn-edit-submit">Approve</CButton>
                            <CButton v-if="viewStatus == 'Menunggu Persetujuan'" @click="onSave('R')" type="button" style="float:right" class="btn btn-edit-reject mr-2">Reject</CButton>
                            <CButton @click="closeModal()" type="button" style="float:right" class="btn btn-cancel mr-2">Back</CButton>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
        <CModal
        size="md"
        :centered="true"
        :color="actColor"
        :show.sync="actModal"
        :closeOnBackdrop="false"
        >
        <template #header-wrapper>
            <div class="headers-modal">
                <CRow>
                    <CCol sm="10">
                        <div>Konfirmasi {{actTitle}}</div>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img :src="closeIcon" @click="actModal = false,keteranganApprove = ''" style="cursor:pointer" width="20px" height="20px"/>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #body-wrapper>
            <div style="padding-right:20px;padding-left:20px">
                <CRow>
                    <CCol sm="12">
                        <label>Masukan Keterangan</label>
                        <textarea v-model="keteranganApprove" placeholder="Keterangan" class="form-control"/>
                    </CCol>
                </CRow>
                <CRow class="mt-4" v-if="errFlag == true">
                    <CCol sm="12">
                        <span class="text-danger" style="font-size:12px">*Keterangan harus diisi</span>
                    </CCol>
                </CRow>
            </div>
            <CRow class="mt-4" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                <CCol sm="6">
                    <CButton style="width:100%!important" @click="actModal = false,keteranganApprove = ''" class="btn-cancel">Back</CButton>
                </CCol>
                <CCol sm="6">
                    <CButton v-if="actColor == 'red'" style="width:100%!important" @click="goSave('R')" class="btn-edit-delete">Reject</CButton>
                    <CButton v-if="actColor == 'white'" style="width:100%!important" @click="goSave('A')" class="btn-edit-submit">Approve</CButton>
                </CCol>
            </CRow>
        </template>
        <template #footer-wrapper><span></span></template>
    </CModal>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tableApprovalBilling'
import { DataApi, DataApiUpload } from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'
export default {
    components: {
        Tables,
        ModelSelect
    },
    data() {
        return {
            success: true,
            // datas
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
            closeIcon: require('../../../assets/menu/icon_close.svg'),
            dataTh: ['Nama Perusahaan', 'Tanggal Expired', 'Action'],
            dataTd: ['namaPerusahaan', 'tanggalExpired', 'action'],
            styleTable: ['300px', '200px', '100px'],
            classReload: 'reloadOff',
            datas: [],
            datasDetail: [],
            goArea: true,
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,

            // data model
            kode: '',
            namaPerusahaan: '',
            tanggalExpired: '',

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // paging detail
            pageDetail: 1,
            sizeDetail: 20,
            totalRowDetail: 0,
            totalPageDetail: 1,
            firstPageDetail: 0,
            lastPageDetail: 0,

            // filter
            searchPerusahaan: '',

            // error
            errorMessage: '',
            errorMessageDetail: '',

            // modal
            viewNamaPerusahaan: '',
            viewPeriode: '',
            viewSatuan: '',
            viewHarga: 0,
            viewJumlahPegawai: '',
            viewTotalTagihan: 0,
            viewStatus: '',
            viewBukti: '',
            viewJumlahBulan: '',
            viewTotalBayar: '',
            viewKeterangan: [],
            viewUnix: '',
            viewNamaApproval: '',
            viewTanggalApprove: '',
            viewTipePdf: '',
            viewModal: false,

            // modal action
            actModal: false,
            actTitle: '',
            actColor: '',
            keteranganApprove: '',
            errFlag: false,

            dataSearchStatus: [],
            selectedStatus: {
                text: '',
                value: '',
            },
            flagSearch: false,
            flagSearchDetail: false
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        pageDetail() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        searchPerusahaan() {
            this.flagSearch = true
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        selectedStatus() {
            this.flagSearch = true
            this.getData()
        }
    },
    computed: {
    },
    methods: {
        getDataStatus() {
            this.dataSearchStatus = [
                { value: '', text: 'Semua' },
                { value: 'W', text:'Belum Lunas' },
                { value: 'A', text:'Lunas' },
                { value: 'B', text:'Menunggu' }
            ]
        },
        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.kode.toLowerCase() < b.kode.toLowerCase()) {
                        return -1
                    }
                    if (a.kode.toLowerCase() > b.kode.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.keterangan.toLowerCase() < b.keterangan.toLowerCase()) {
                        return -1
                    }
                    if (a.keterangan.toLowerCase() > b.keterangan.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let payload = {
                limit: this.size,
                namaPerusahaan: this.searchPerusahaan,
                pageIn: this.page,
                status: this.selectedStatus.value
            }
            DataApi.post("billing/perusahaan/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        reload() {
            this.searchPerusahaan = ''
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        movePageDetail(direction) {
            if(direction == 'prev') {
                this.pageDetail = this.pageDetail -  1
            } else {
                this.pageDetail = this.pageDetail +  1
            }
            this.getDataDetail()
        },
        validatePageDetail(page) {
            if(page > this.totalPage) {
                this.pageDetail = this.totalPageDetail
            }
        },

        /**
         * ADD DATA
         */
        moving() {
            setTimeout(this.moveArea, 600);
        },
        moveArea() {
            if(this.goArea == true) {
                this.goArea = false
            } else {
                this.goArea = true
                this.pageDetail = 1
                this.sizeDetail = 20
                this.totalRowDetail = 0
                this.totalPageDetail = 1
                this.firstPageDetail = 0
                this.lastPageDetail = 0
                this.kode = ''
                this.namaPerusahaan = ''
                this.tanggalExpired = ''
                this.$v.$reset()
            }
        },
        onSave(val) {
            this.errFlag = false
            if(val == 'R') {
                this.actTitle = 'Penolakan'
                this.actColor = 'red'
            } else if(val == 'A') {
                this.actTitle = 'Persetujuan'
                this.actColor = 'white'
            }
            this.actModal = true
        },
        goSave(val) {
            if(this.keteranganApprove.length == 0) {
                this.errFlag = true
            } else {
                let payload = {
                    keterangan: this.keteranganApprove,
                    tipe: val,
                    unix: this.viewUnix
                }
                DataApi.post("billing/approve", payload)
                .then(res => {
                    this.actModal = false
                    let response = res.data
                    if(response.success == true) {
                        if(response.data.Data1 == 'Y') {
                            this.success = true
                        } else {
                            this.success = false
                        }
                        this.alertMess = response.data.Data2
                    } else {
                        this.alertMess = response.message
                        this.success = false
                    }
                    this.getDataDetail()
                    this.closeModal()
                    this.currentAlertCounter = 7
                })
            }
        },

        /**
         * EDIT DATA
         */
        editData(value) {
            let generate = this.datas[value]
            this.kode = generate.kode
            this.namaPerusahaan = generate.namaPerusahaan
            this.tanggalExpired = generate.tanggalExpired
            this.moving()
            this.getDataDetail()
        },
        getDataDetail() {
            if(this.flagSearchDetail == true) {
                this.pageDetail = 1
            }
            this.$store.state.loadingScreen = true
            let payload = {
                limit: this.sizeDetail,
                organisasi: this.kode,
                pageIn: this.pageDetail
            }
            DataApi.post("billing/admin/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datasDetail = response.data.data
                    this.totalRowDetail = response.data.totalRow
                    this.firstPageDetail = (((this.pageDetail - 1) * this.sizeDetail) + 1 )
                    this.lastPageDetail = (((this.pageDetail - 1) * this.sizeDetail) + this.datasDetail.length )
                    this.totalPageDetail = Math.floor(this.totalRowDetail/this.sizeDetail)
                    let modAr = this.totalRowDetail%this.sizeDetail
                    if(modAr != 0) {
                        this.totalPageDetail = this.totalPageDetail + 1
                    } else {
                        //
                    }
                } else {
                    this.datasDetail = []
                    this.totalRowDetail = 0
                    this.firstPageDetail = 0
                    this.lastPageDetail = 0
                    this.totalPageDetail = 1
                    this.errorMessageDetail = response.message
                }
                this.flagSearchDetail = false
                this.$store.state.loadingScreen = false
            })
        },
        openModal(val) {
            let temp = this.datasDetail[val]
            this.viewNamaPerusahaan = temp.namaPerusahaan
            this.viewPeriode = temp.periode

            if(temp.tipeBilling == 'S') {
                this.viewSatuan = 'Satuan'
                this.viewHarga = temp.hargaSatuan
                this.rupiahModeUangSakuView('harga')
                this.viewJumlahPegawai = temp.jumlahPegawai
            } else if(temp.tipeBilling == 'P') {
                this.viewSatuan = 'Paket'
                this.viewJumlahPegawai = temp.maxPegawai
                this.viewHarga = temp.totalHarga
                this.rupiahModeUangSakuView('harga')
            }

            if(temp.status == 'W') {
                this.viewStatus = 'Belum Lunas'
            } else if(temp.status == 'A') {
                this.viewStatus = 'Lunas'
            } else if(temp.status == 'B') {
                this.viewStatus = 'Menunggu Persetujuan'
            }

            this.viewTotalTagihan = temp.totalHarga

            this.viewBukti = temp.buktiBayar
            this.viewJumlahBulan = temp.jumlahBulan
            this.viewTotalBayar = temp.totalBayar
            this.viewNamaApproval = temp.namaApprover
            this.viewTanggalApprove = temp.tanggalApproved
            this.viewKeterangan = temp.history
            this.viewUnix = temp.unix
            this.viewTipePdf = temp.tipePdf
            this.rupiahModeUangSakuView('bayar')
            this.rupiahModeUangSakuView('total')
            this.viewModal = true
        },
        closeModal() {
            this.viewNamaPerusahaan = ''
            this.viewPeriode = ''
            this.viewSatuan = ''
            this.viewHarga = 0
            this.viewJumlahPegawai = ''
            this.viewTotalTagihan = 0
            this.viewStatus = ''
            this.viewBukti = ''
            this.viewJumlahBulan = ''
            this.viewTotalBayar = ''
            this.viewNamaApproval = ''
            this.viewTanggalApprove = ''
            this.viewUnix = ''
            this.viewTipePdf = ''
            this.viewModal = false
        },
        direct(link) {
            window.open(link)
        },
        rupiahModeUangSakuView(param) {
            let angka = ''
            if(param == 'bayar') {
                angka = this.viewTotalBayar
            } else if(param == 'harga') {
                angka = this.viewHarga
            } else if(param == 'total') {
                angka = this.viewTotalTagihan
            }
            var number_string = angka.toString().replace(/[^,\d]/g, '')
            var split           = number_string.split(',')
            var sisa             = split[0].length % 3
            var rupiah             = split[0].substr(0, sisa)
            var ribuan             = split[0].substr(sisa).match(/\d{3}/gi)
            var prefix = "Rp. "
        
            // tambahkan titik jika yang di input sudah menjadi angka satuan ribuan
            if(ribuan){
                var separator = sisa ? '.' : '';
                rupiah += separator + ribuan.join('.');
            }
        
            rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
            let hasil = prefix == undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '');
            if(param == 'bayar') {
                this.viewTotalBayar = hasil
            } else if(param == 'harga') {
                this.viewHarga = hasil
            } else if(param == 'total') {
                this.viewTotalTagihan = hasil
            }
        },
        rupiahModeUangSaku(param) {
            let angka = param
            var number_string = angka.toString().replace(/[^,\d]/g, '')
            var split           = number_string.split(',')
            var sisa             = split[0].length % 3
            var rupiah             = split[0].substr(0, sisa)
            var ribuan             = split[0].substr(sisa).match(/\d{3}/gi)
            var prefix = "Rp. "
        
            // tambahkan titik jika yang di input sudah menjadi angka satuan ribuan
            if(ribuan){
                var separator = sisa ? '.' : '';
                rupiah += separator + ribuan.join('.');
            }
        
            rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
            let hasil = prefix == undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '');
            return hasil
        },
        showPdf(val) {
            this.$store.state.loadingScreen = true
            let payload = {
                unix: val
            }
            DataApi.post("/export/billing/pdf", payload , {responseType: 'blob'})
            .then(res => {
                let response = res.data
                const url = URL.createObjectURL(new Blob([response], {
                    type: 'application/pdf'
                }))
                window.open(url)
                this.$store.state.loadingScreen = false
            })
        },
        showPdfBukti(val) {
            this.$store.state.loadingScreen = true
            DataApiUpload.get('load/' + val)
            .then( res => {
                let openWindow = res.config.baseURL + res.config.url
                window.open(openWindow)
                this.$store.state.loadingScreen = false
            })
        },
        separators(totals) {
            let val = totals.toString()
            let leng = val.length
            let sisa 	= leng % 3
            let rupiah 	= val.substr(0, sisa)
            let ribuan 	= val.substr(sisa).match(/\d{3}/g)
                
            if (ribuan) {
                let separator = sisa ? '.' : ''
                rupiah += separator + ribuan.join('.')
            }
            return rupiah
        },
    },
    mounted() {
        this.errorMessage = 'Find Your Data',
        this.getDataStatus()
    }
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}

.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 32px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.btn-edit-reject {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:red;
    color: white;
    font-size: 14px;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
input[type="checkbox"] {
    width: 16px;
    height: 16px;
    margin-right: 8px;
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.modal-buttons {
    width:156px;
    height: 36px;
}
.btn-edit-delete {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:red;
    color: white;
    font-size: 14px;
}
.StepProgress {
    position: relative;
    padding-left: 45px;
    list-style: none;
}
.StepProgress::before {
    display: inline-block;
    content: '';
    position: absolute;
    top: 5px;
    left: 15px;
    width: 10px;
    height: 80%;
    border-left: 2px solid #CCC;
}
.StepProgress-item {
    position: relative;
    counter-increment: list;
}
.StepProgress-item:not(:last-child) {
    padding-bottom: 20px;
}
.StepProgress-item::before {
    display: inline-block;
    content: '';
    position: absolute;
    top: 10px;
    left: -30px;
    height: 100%;
    width: 10px;
}
.StepProgress-item::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 5px;
    left: -35px;
    width: 12px;
    height: 12px;
    border: 2px solid #CCC;
    border-radius: 50%;
    background-color: #FFF;
}
.StepProgress-item.is-done::before {
    border-left: 2px solid rgba(21, 100, 153, 1);
}
.StepProgress-item.is-done::after {
    font-size: 10px;
    color: #FFF;
    text-align: center;
    border: 2px solid rgba(21, 100, 153, 1);
    background-color: rgba(21, 100, 153, 1);
}
.StepProgress strong {
    display: block;
}
</style>
